<template>
  <div id="fullpage__wrapper">
    <slot/>
  </div>
</template>

<style lang="scss">
#fullpage__wrapper{
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;

}
</style>